/*
 * @Date: 2025-04-01 17:52:01
 * @Description:服务商订单管理
 */
import AspOrder from '../views/asp-order.vue';
import UnfinishedOrderDetailC from '../views/unfinished-order-detail-c.vue';
import UnfinishedOrderDetailB from '../views/unfinished-order-detail-b.vue';
import UnfinishedOrderDetailS from '../views/unfinished-order-detail-s.vue';

import FinishedOrderDetailC from '../views/finished-order-detail-c.vue';
import FinishedOrderDetailB from '../views/finished-order-detail-b.vue';
import FinishedOrderDetailS from '../views/finished-order-detail-s.vue';

/**
 * taxType:1-经营(operate) 2-劳务(labor)
 */

export const route = [
  {
    path: '/main/asp/order',
    name: 'asp-order',
    meta: {
      title: '订单管理',
      taxType: 1
    },
    component: AspOrder
  },
  {
    path: '/main/asp/labor-order',
    name: 'asp-labor-order',
    meta: {
      title: '订单管理',
      taxType: 2
    },
    component: AspOrder
  },
  // 个人&个体&供应商子集个人的项目费用订单详情
  /***************************************未完结订单详情*********************************************** */
  {
    path: '/main/asp/unfinished-order/detail-c',
    name: 'asp-unfinished-order-detail-c',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/order',
      taxType: 1
    },
    component: UnfinishedOrderDetailC
  },
  {
    path: '/main/asp/unfinished-labor-order/detail-c',
    name: 'asp-unfinished-labor-order-detail-c',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/labor-order',
      taxType: 2
    },
    component: UnfinishedOrderDetailC
  },
  // 供应商项目费用订单详情
  {
    path: '/main/asp/unfinished-order/detail-b',
    name: 'asp-unfinished-order-detail-b',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/order',
      taxType: 1
    },
    component: UnfinishedOrderDetailB
  },
  {
    path: '/main/asp/unfinished-labor-order/detail-b',
    name: 'asp-unfinished-labor-order-detail-b',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/labor-order',
      taxType: 2
    },
    component: UnfinishedOrderDetailB
  },
  // 平台/商务服务费订单详情
  {
    path: '/main/asp/unfinished-order/detail-s',
    name: 'asp-unfinished-order-detail-s',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/order',
      taxType: 1
    },
    component: UnfinishedOrderDetailS
  },
  {
    path: '/main/asp/unfinished-labor-order/detail-s',
    name: 'asp-unfinished-labor-order-detail-s',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/labor-order',
      taxType: 2
    },
    component: UnfinishedOrderDetailS
  },
  /***************************************已完结订单详情*********************************************** */
  {
    path: '/main/asp/finished-order/detail-c',
    name: 'asp-finished-order-detail-c',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/order',
      taxType: 1
    },
    component: FinishedOrderDetailC
  },
  {
    path: '/main/asp/finished-labor-order/detail-c',
    name: 'asp-finished-labor-order-detail-c',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/labor-order',
      taxType: 2
    },
    component: FinishedOrderDetailC
  },
  // 供应商项目费用订单详情
  {
    path: '/main/asp/finished-order/detail-b',
    name: 'asp-finished-order-detail-b',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/order',
      taxType: 1
    },
    component: FinishedOrderDetailB
  },
  {
    path: '/main/asp/finished-labor-order/detail-b',
    name: 'asp-finished-labor-order-detail-b',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/labor-order',
      taxType: 2
    },
    component: FinishedOrderDetailB
  },
  // 平台/商务服务费订单详情
  {
    path: '/main/asp/finished-order/detail-s',
    name: 'asp-finished-order-detail-s',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/order',
      taxType: 1
    },
    component: FinishedOrderDetailS
  },
  {
    path: '/main/asp/finished-labor-order/detail-s',
    name: 'asp-finished-labor-order-detail-s',
    meta: {
      title: '订单详情',
      parentPath: '/main/asp/labor-order',
      taxType: 2
    },
    component: FinishedOrderDetailS
  }
];
